const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Meets redirect component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('meetsRedirect', ['Application', 'Authorization', 'Meets', function (Application, Authorization, Meets) {
  return {
    restrict: 'E',
    replace: false,
    scope: {},
    link: function(scope, element, attrs) {
      var self = this;
      self.user = Authorization.getAuthToken().user;
      var params = Application.navigation.getUrlParameters();

      if (params.code && params.code !== 'null') {
        Meets.submitCode({}, {code: params.code}).$promise
        .then(function(result) {
          Application.messaging.addMessage({type: 'success', duration: 7, text: 'Integration successfull! You can now create Google Meet links within workshops.'});
          Application.navigation.goTo('/dashboard/activity');
          return;
        }).catch(function(error) {
          Application.messaging.addMessage({type: 'error', duration: 5, text: 'Unable to integrate with Google at this time.'});
          Application.navigation.goTo('/dashboard');
          return;
        });
      }

      if (params.error && params.error !== 'null') {
        if (params.error === 'access_denied') {
          Application.messaging.addMessage({type: 'error', duration: 5, text: 'You have denied access to your Google Calendar.'});
          Application.navigation.goTo('/dashboard');
          return;
        }
        Application.messaging.addMessage({type: 'error', duration: 5, text: 'Unable to integrate with Google at this time.'});
        Application.navigation.goTo('/dashboard');
        return;
      }

    }
  };
}]);